// The SaaS paywall gate's copy: which sentence a denied merchant reads.
//
// Its own module so PricingGate.jsx exports only a component.
//
// WHICH sentence is true is decided by `billing/paywallCopy`; only the KEYS
// live here.

import { PAYWALL_COPY, paywallCopyKind } from '../../billing/paywallCopy';

// Which SaaS strings each paywall KIND renders. Thunks rather than a plain
// object because `t` is only available inside the component, and a module
// -level table must not capture a translator from one render.
export const GATE_COPY = {
  [PAYWALL_COPY.PAYMENT_ON_HOLD]: (t) => ({
    gateHeading: t('billing.gate.paymentOnHoldTitle'),
    gateBanner: t('billing.gate.paymentOnHoldBanner'),
    ctaLabel: t('billing.gate.resubscribe'),
  }),
  [PAYWALL_COPY.BLOCKED]: (t) => ({
    gateHeading: t('billing.gate.inactiveTitle'),
    gateBanner: t('billing.gate.blockedBanner'),
    ctaLabel: t('billing.gate.resubscribe'),
  }),
  [PAYWALL_COPY.LAPSED]: (t) => ({
    gateHeading: t('billing.gate.inactiveTitle'),
    gateBanner: t('billing.gate.lapsedBanner'),
    ctaLabel: t('billing.gate.subscribe'),
  }),
  // The evaluation window closed with nothing to bill (`trial_expired`, or
  // a development store's `test_subscription`): the one sentence the free
  // period gets anywhere on the SaaS.
  [PAYWALL_COPY.TRIAL_ENDED]: (t) => ({
    gateHeading: t('billing.gate.chooseTitle'),
    gateBanner: t('billing.gate.freePeriodEnded'),
    ctaLabel: t('billing.gate.subscribe'),
  }),
  [PAYWALL_COPY.CHOOSE]: (t) => ({
    gateHeading: t('billing.gate.chooseTitle'),
    gateBanner: null,
    ctaLabel: t('billing.gate.subscribe'),
  }),
};

/**
 * The heading, banner and CTA for a denied merchant's billing status.
 *
 * @param {Function} t              i18next translator
 * @param {object} billingStatus    the /api/billing/status/ payload
 */
export function gateCopy(t, billingStatus) {
  return GATE_COPY[paywallCopyKind({
    status: billingStatus.status,
    needsResubscribe: billingStatus.needs_resubscribe,
  })](t);
}
